import * as React from 'react';
import Icon from '../../../../icons/Icon';

export default class ApartmentsBlockIcon extends Icon {
    renderIcon() {
        return (
            <svg width={this.getSize()} height={this.getSize()} xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0" y="0" viewBox="0 0 514 514">
                <circle cx="257" cy="257" r="257" fill="#FFFFFF"></circle>
                <g>
                    <defs>
                        <circle id="SVGID_1_" cx="257" cy="257" r="257"></circle>
                    </defs>
                    <clipPath id="SVGID_00000098183826311608278240000001827420291171983775_">
                        <use overflow="visible" xlinkHref="#SVGID_1_"></use>
                    </clipPath>
                    <path
                        fill="#4D5E80"
                        d="M463.626 414.328h-45.719a4.375 4.375 0 01-4.373-4.374V186.843h-71.357v223.111a4.376 4.376 0 01-4.376 4.374H319.91a4.375 4.375 0 01-4.376-4.374V131.357H271.86v70.173a4.38 4.38 0 01-1.312 3.126c-.841.822-1.998 1.302-3.154 1.246l-62.978-1.361v205.412a4.374 4.374 0 01-4.374 4.374h-17.894a4.373 4.373 0 01-4.374-4.374v-299.64l-77.309 46.88v252.761a4.375 4.375 0 01-4.373 4.374H50.374a4.374 4.374 0 010-8.748H91.72V154.73a4.38 4.38 0 012.104-3.74l86.057-52.182a4.379 4.379 0 014.414-.072 4.376 4.376 0 012.228 3.812V405.58h9.145V200.073c0-1.176.475-2.304 1.313-3.126.841-.823 1.979-1.333 3.154-1.246l62.98 1.361v-70.078a4.372 4.372 0 014.371-4.374h52.425a4.372 4.372 0 014.371 4.374V405.58h9.147V182.47a4.373 4.373 0 014.373-4.373h80.105a4.374 4.374 0 014.375 4.373v223.11h41.344a4.375 4.375 0 010 8.748z"
                        clipPath="url(#SVGID_00000098183826311608278240000001827420291171983775_)"
                    ></path>
                </g>
            </svg>
        );
    }
}
